"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _Error = require("b2b-components/theme/components/Form/common/Error");
var _Label = require("b2b-components/theme/components/Form/Label");
var _Icon = require("b2b-components/theme/components/Icon");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Info = require("../common/Info");
var _Select = require("./Select.types");
require("./Select.scss");
const Select = _ref => {
  let {
    defaultValue,
    onChange = () => undefined,
    value,
    selectId,
    text = {
      label: '',
      placeholder: '',
      required: '*',
      optional: '(optional)'
    },
    name,
    error = null,
    info = null,
    isDisabled = false,
    markingType = _Label.MARKING_TYPE.none,
    styleType = _Select.STYLE_TYPE.outlined,
    autocomplete,
    dataAttributes,
    inputClassName,
    className,
    options
  } = _ref;
  const [stateValue, setStateValue] = (0, _reactUseControlledState.default)(defaultValue, value, onChange);
  const handleChange = e => {
    setStateValue(e.currentTarget.value);
  };
  const rootClassName = (0, _classnames.default)('cds-Form-Input', `cds-Form-Input--${(0, _upperCase.upperCaseFirst)(styleType)}`, {
    'cds-Form-Input--Error': error
  }, className);
  let placeholderOption;
  if (text.placeholder) {
    placeholderOption = /*#__PURE__*/_react.default.createElement("option", {
      disabled: true,
      value: "",
      key: "placeholder"
    }, text.placeholder);
  }
  const selectOptions = [placeholderOption, ...options.map(option => /*#__PURE__*/_react.default.createElement("option", {
    value: option.value,
    key: option.value,
    disabled: option.isDisabled
  }, option.label))];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react.default.createElement(_Label.Label, {
    markingType: markingType,
    text: text,
    className: "cds-Form-Label cds-Select-Label",
    htmlFor: selectId
  }, text.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Select"
  }, /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    autoComplete: autocomplete,
    disabled: isDisabled,
    id: selectId,
    onChange: handleChange,
    value: stateValue,
    name: name,
    className: (0, _classnames.default)('cds-Select-Input', inputClassName)
  }), selectOptions), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-Select-Icon",
    name: _Icon.ICON_NAME.arrowDown
  }))), error && /*#__PURE__*/_react.default.createElement(_Error.Error, null, error), info && /*#__PURE__*/_react.default.createElement(_Info.Info, null, info));
};
exports.Select = Select;
//# sourceMappingURL=Select.js.map